import React from 'react';

import { block } from 'bem-cn';

import Tag from 'components/Tag';
import Typography from 'components/Typography';

import './square-plate.scss';

const b = block('square-plate');

type SquarePlatePropsType = {
  size: number;
  icon: any;
  avatar: any;
  tag: string;
  backgroundImage: any;
  title: string;
};

const padding = '8pt';

const SquarePlate = ({
  size,
  icon,
  avatar,
  tag,
  backgroundImage,
  title,
}: SquarePlatePropsType) => {
  const getPlateSize = () => `${size}pt`;
  const getPlateImageSize = () => `calc(${getPlateSize()} - ${padding} * 2`;

  const plateStyles = {
    padding,
    width: getPlateImageSize(),
    height: getPlateImageSize(),
    backgroundImage: backgroundImage ? `url(${backgroundImage})` : undefined,
  };

  return (
    <div className={b()} style={{ width: getPlateSize() }}>
      <div className={b('plate')} style={plateStyles}>
        <div className={b('top-row', { 'with-icon': !!icon })}>
          {icon && (
            <div className={b('icon')}>
              <img src={icon} alt='icon' />
            </div>
          )}
          {tag && <Tag text={tag} />}
        </div>
        <div className={b('bottom-row')}>
          {avatar && (
            <div className={b('avatar')}>
              <img src={avatar} alt='avatar' />
            </div>
          )}
        </div>
      </div>
      {title && (
        <div className={b('title')}>
          <Typography
            className={b('title-text')}
            component='div'
            variant={Typography.THEME.VARIANTS.TEXT_BIG}
          >
            {title}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default SquarePlate;
